import { render, staticRenderFns } from "./big-map.vue?vue&type=template&id=237242dd&scoped=true&"
import script from "./big-map.vue?vue&type=script&lang=js&"
export * from "./big-map.vue?vue&type=script&lang=js&"
import style0 from "./big-map.vue?vue&type=style&index=0&id=237242dd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237242dd",
  null
  
)

export default component.exports